import Chart from "react-google-charts";
import React, { Component } from 'react';
import DBService from '../../service/DBService';
import { useNavigate } from 'react-router-dom';


class AdvanceDeclineChartWithNavigate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: []
    };
    console.log('this.props', this.props);
  }

  componentDidMount() {
    DBService.getAdvanceDecline()
      .then(result => {
        result = result.data;
        console.log('getAdvanceDecline', result);
        let greenColor = '#6BA583';
        let redColor = '#FF6666';

        let filteredData = [];
        // filteredData.push(['Market', 'Bull',  {type: 'string', role: 'annotation'},'Bear',{type: 'string', role: 'annotation'}]);
        // for (var i = 0; i < result.length; i++) {
        //   let total=result[i].total_stocks_count;      
        //   filteredData.push(['Advance/Decline', result[i].advancing, parseFloat(result[i].advancing/total*100).toFixed(2)+'%', 
        //       result[i].declining, parseFloat(result[i].declining/total*100).toFixed(2)+'%']);
        //   filteredData.push(['52 Week High/Low', result[i].yearHighCount, parseFloat(result[i].yearHighCount/total*100).toFixed(2)+'%',
        //       result[i].yearLowCount, parseFloat(result[i].yearLowCount/total*100).toFixed(2)+'%']);
        //   filteredData.push(['Price Above SMA50', result[i].priceabove50, parseFloat(result[i].priceabove50/total*100).toFixed(2)+'%', 
        //       result[i].pricebelow50,  parseFloat(result[i].pricebelow50/total*100).toFixed(2)+'%']);
        //   filteredData.push(['Price Above SMA200', result[i].priceabove200, parseFloat(result[i].priceabove200/total*100).toFixed(2)+'%', 
        //       result[i].pricebelow200, parseFloat(result[i].pricebelow200/total*100).toFixed(2)+'%']);
        // }

       filteredData.push(['Market', '',  {type: 'string', role: 'annotation'}, {role:'style'}]);
        for (var i = 0; i < result.length; i++) {
          let total=result[i].total_stocks_count;      
          filteredData.push(['Advance', result[i].advancing, parseFloat(result[i].advancing/total*100).toFixed(2)+'%', greenColor]);
          filteredData.push(['Decline', result[i].declining, parseFloat(result[i].declining/total*100).toFixed(2)+'%', redColor]);

          filteredData.push(['52 Week High', result[i].yearHighCount, parseFloat(result[i].yearHighCount/total*100).toFixed(2)+'%', greenColor]);
          filteredData.push(['52 Week Low', result[i].yearLowCount, parseFloat(result[i].yearLowCount/total*100).toFixed(2)+'%', redColor]);

          filteredData.push(['Price Above SMA50', result[i].priceabove50, parseFloat(result[i].priceabove50/total*100).toFixed(2)+'%', greenColor]);
          filteredData.push(['Price Below SMA50', result[i].pricebelow50, parseFloat(result[i].pricebelow50/total*100).toFixed(2)+'%', redColor]);

          filteredData.push(['Price Above SMA200', result[i].priceabove200, parseFloat(result[i].priceabove200/total*100).toFixed(2)+'%', greenColor]);
          filteredData.push(['Price Below SMA200', result[i].pricebelow200, parseFloat(result[i].pricebelow200/total*100).toFixed(2)+'%', redColor]);          
        }        
        this.setState({ data: filteredData });
        console.log('filteredData', filteredData, JSON.stringify(filteredData));
        console.log('data', JSON.stringify(this.state.data));
      })
      .catch((error) => {
        console.log(error);
      });

  }

  render() {
    if (this.state === null) {
      return <div>Loading...</div>
    }
    if (this.state.data === null || this.state.data.length <= 0) {
      return <div>No Data</div>
    }
    return (
      <Chart
        width={'220px'}
        height={'225px'}
        chartType="BarChart"
        loader={<div>Loading Chart</div>}
        data={this.state.data}
        options={{
          title: 'Bull/Bear Ratio',
          isStacked: false,
          chartArea: { left: 110, top: 20, bottom: 10, right: 30, width: '50%', height: '50%' },
          // hAxis: {
          //   title: 'Percentage (%)',
          //   minValue: 0,
          // },
          // vAxis: {
          //   title: '',
          // },
          legend: { position: 'none' },
          colors: ['#6BA583', '#FF6666'],
          //alwaysOutside : true,
          // textStyle: {
          //   fontSize: 14,
          //   color: '#000',
          //   auraColor: 'none'
          // }
        
        }}
        chartEvents={[
          {
            eventName: "ready",
            callback: ({ chartWrapper, google }) => {
              const chart = chartWrapper.getChart();
              google.visualization.events.addListener(chart, "select", e => {
                console.log('click', chart.getSelection(), this.props);
                // const { row, column } = chart.getSelection()[0];
                // console.log('click', chart.getSelection(), row, column, this.state.data[row], this.props);
                // let sectorName = this.state.data[row+1][0];
                // let result = this.state.data[row+1][0];
                // if (sectorName === 'Comm. Services') {result = 'Communication Services'};
                // if (sectorName === 'Cons. Cyclical') {result = 'Consumer Cyclical'};
                // if (sectorName === 'Cons. Defensive') {result = 'Consumer Defensive'};
                // if (sectorName === 'Fin. Services') {result = 'Financial Services'};
                // console.log('click sector', result, sectorName);
                // this.props.navigate('/screener/country/US/sector/'+ result);
              });
            }
          }
        ]}

        // For tests
        rootProps={{ 'data-testid': '1' }}
      />
    )
  }
}

function AdvanceDeclineChart(props) {
  let navigate = useNavigate();
  return <AdvanceDeclineChartWithNavigate {...props} navigate={navigate} />
}

export default AdvanceDeclineChart;


